// src/components/Sidebar.js
import React, { useEffect } from 'react';
import { FiServer } from 'react-icons/fi';

export default function Sidebar({ item, currentServer, selectedSeason, selectedEpisode, episodes }) {

  // =======================================================================
  // USE EFFECT TO LOAD YOUR SPECIFIC AD SCRIPT
  // =======================================================================
  useEffect(() => {
    // This is the container where the ad will be placed.
    const adContainer = document.getElementById('sidebar-ad-container');
    if (!adContainer) return;

    // 1. Create the configuration script
    const configScript = document.createElement('script');
    configScript.type = 'text/javascript';
    configScript.innerHTML = `
      atOptions = {
        'key' : '863fe57d228f2b0b968cc865ff125996',
        'format' : 'iframe',
        'height' : 50,
        'width' : 320,
        'params' : {}
      };
    `;

    // 2. Create the invocation script
    const invokeScript = document.createElement('script');
    invokeScript.type = 'text/javascript';
    // The 'https:' is added to prevent protocol-relative URL issues
    invokeScript.src = 'https://www.highperformanceformat.com/863fe57d228f2b0b968cc865ff125996/invoke.js';

    // 3. Append the scripts to the container so the ad loads in the right place
    adContainer.appendChild(configScript);
    adContainer.appendChild(invokeScript);

    // 4. Cleanup function to remove scripts when the component unmounts
    return () => {
      if (adContainer) {
        adContainer.innerHTML = ''; // Clear the container
      }
    };
  }, []); // The empty array [] ensures this effect runs only once.
  // =======================================================================


  const episodeData = episodes.find(e => e.episode_number === selectedEpisode);
  const serverName = () => {
    if (currentServer === "player.videasy.net") return <span className="text-green-400">Server 1 (Recommended)</span>;
    if (currentServer === "vidsrc.cc") return "Server 2";
    return "Server 3";
  };

  return (
    <div className="bg-gray-800 rounded-lg overflow-hidden p-3 sm:p-4 border border-gray-700 sticky top-4">

      {/* ================================================================ */}
      {/* ADVERTISEMENT CONTAINER (320x50)                               */}
      {/* The useEffect hook above will inject your ad script here.      */}
      {/* ================================================================ */}
      <div 
        id="sidebar-ad-container" 
        className="mb-4 flex justify-center items-center"
        style={{ width: '320px', height: '50px', margin: '0 auto' }}
      >
        {/* The ad iframe will be created here by the script */}
      </div>
      {/* ================================================================ */}
      
      <h3 className="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4 flex items-center justify-center gap-2">
        <FiServer className="text-blue-400 text-sm sm:text-base" />
        <span>Streaming Information</span>
      </h3>
      <div className="space-y-3 sm:space-y-4">
        <div className="space-y-1 text-center">
          <p className="text-gray-400 text-xs sm:text-sm">Current Server</p>
          <p className="text-gray-300 font-medium text-sm sm:text-base">{serverName()}</p>
        </div>
        {item.media_type === 'tv' && (
          <>
            <div className="space-y-1 text-center"><p className="text-gray-400 text-xs sm:text-sm">Current Season</p><p className="text-gray-300 font-medium text-sm sm:text-base">Season {selectedSeason}</p></div>
            <div className="space-y-1 text-center"><p className="text-gray-400 text-xs sm:text-sm">Current Episode</p><p className="text-gray-300 font-medium text-sm sm:text-base">Episode {selectedEpisode}</p></div>
            <div className="space-y-1 text-center"><p className="text-gray-400 text-xs sm:text-sm">Episode Title</p><p className="text-gray-300 font-medium text-sm sm:text-base">{episodeData?.name || 'N/A'}</p></div>
            <div className="space-y-1 text-center"><p className="text-gray-400 text-xs sm:text-sm">Air Date</p><p className="text-gray-300 font-medium text-sm sm:text-base">{episodeData?.air_date ? new Date(episodeData.air_date).toLocaleDateString() : 'N/A'}</p></div>
          </>
        )}
        <div className="pt-3 sm:pt-4 border-t border-gray-700 text-center">
          <p className="text-xs text-gray-500">
            If playback issues occur, try switching to a different server.
            {item.media_type === 'tv' && ' Unreleased episodes are disabled.'}
          </p>
        </div>
      </div>
    </div>
  );
}
